export const locale = {
    lang: 'pl',
    data: {
        "New": "Nowy",
        "Manufacturers": "Producenci",
        "Name": "Nazwa",
        "Actions": "Akcje",
        "Edit": "Edycja",
        "Manufacturer data": "Dane producenta",
        "Save": "Zapisz"
    }
};
